import React, { useState } from "react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | ok | error | loading
  const [msg, setMsg] = useState("");

  const handleSubscribe = async () => {
    const value = email.trim();
    if (!value || !value.includes("@")) {
      setState("error");
      setMsg("Veuillez entrer un email valide.");
      return;
    }

    setState("loading");
    setMsg("");

    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: value }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        setState("ok");
        setMsg("Merci pour votre abonnement !");
        setEmail("");
      } else {
        setState("error");
        setMsg(data.error || "Erreur d’abonnement.");
      }
    } catch {
      setState("error");
      setMsg("Erreur serveur.");
    }
  };

  return (
    <section className="section">
      <div className="container">
        <div className="card cardPad" style={{ textAlign: "center" }}>
          <h3 className="h2" style={{ fontSize: 20, marginBottom: 6, color: "var(--brand)" }}>
            Newsletter
          </h3>
          <p className="p">Promos, nouveautés, best-sellers. Pas de spam.</p>

          <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 14, flexWrap: "wrap" }}>
            <input
              className="input"
              type="email"
              placeholder="Votre email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: 320, maxWidth: "100%" }}
            />
            <button className="btn" onClick={handleSubscribe} disabled={state === "loading"}>
              {state === "loading" ? "Envoi…" : "S'abonner"}
            </button>
          </div>

          {msg && (
            <div
              className="badge"
              style={{
                marginTop: 12,
                borderColor: state === "error" ? "rgba(179,62,62,.25)" : "rgba(47,122,61,.25)",
              }}
            >
              {state === "error" ? "❌" : "✅"} {msg}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
